export const PREK_GRADE_BANDS = new Set(['K5', 'K3']);
export const QUALITY_DESERT_KINDS = new Set(['quality', 'combined']);

export const GRADE_BAND_SHORT = {
  K5: 'K–5',
  '68': '6–8',
  912: '9–12',
  K3: 'K–3',
  '48': '4–8',
};

export const GRADE_BAND_CHILD_COPY = {
  K5: { band: 'K–5', ages: 'ages 5–10' },
  '68': { band: '6–8', ages: 'ages 11–13' },
  912: { band: '9–12', ages: 'ages 14–17' },
};

export function gradeBandChildCopy(gradeBand) {
  return GRADE_BAND_CHILD_COPY[gradeBand] || {
    band: GRADE_BAND_SHORT[gradeBand] || gradeBand || 'K–12',
    ages: 'school-age',
  };
}

export function gapFeatureKey(feature, index = 0) {
  const properties = feature?.properties || {};
  if (properties.gapRank != null) return String(properties.gapRank);
  if (properties.label) return String(properties.label);
  return String(index);
}

export const showsPrekToggle = (gradeBand) => PREK_GRADE_BANDS.has(gradeBand);

export const showsLowQualityDots = (kind) => QUALITY_DESERT_KINDS.has(kind);

export function ringPopulationBySchoolId(features = []) {
  const byId = {};
  features.forEach((feature) => {
    const props = feature?.properties || feature;
    const id = props?.id;
    if (id == null) return;
    byId[String(id)] = {
      population: props.population,
      populationFuture: props.populationFuture,
      esriYear: props.esriYear,
      esriFutureYear: props.esriFutureYear,
    };
  });
  return byId;
}

export function withRingPopulation(school, byId = {}) {
  const extra = byId[String(school?.id)];
  return extra ? { ...school, ...extra } : school;
}

export function populationYearLabels(meta, properties = {}) {
  return {
    current: String(properties.esriYear || meta?.esriYear || '2026'),
    future: String(properties.esriFutureYear || meta?.esriFutureYear || '2031'),
  };
}

export function qualifiesDistrictPin(school, qualityMode = 'either') {
  const elaOk = school?.elaVsCity === 'Above' || school?.elaVsCity === 'Same';
  const mathOk = school?.mathVsCity === 'Above' || school?.mathVsCity === 'Same';
  if (qualityMode === 'ela') return elaOk;
  if (qualityMode === 'math') return mathOk;
  return elaOk || mathOk;
}
